interface MenuItem {
  name: string;
  url?: string;
  external?: boolean;
  menuLinks?: MenuItem[];
}

export const skipLinks: Array<{ name: string; url: string }> = [
  {
    name: 'Skip to main content',
    url: '#main',
  },
  {
    name: 'Skip to footer',
    url: '#footer',
  },
];

export const getTopLinksWithMenu = (baseUrl?: string): MenuItem[] => {
  const links = [
    {
      name: 'Ways to shop',
      menuLinks: [
        {
          name: 'Services and experiences',
          url: '/our-services',
        },
        {
          name: 'Gift cards',
          url: '/customer-services/prices-and-payment/gift-cards',
        },
        {
          name: 'Our app',
          url: '/customer-services/shopping-with-us/our-apps',
        },
        {
          name: 'Brands A-Z',
          url: '/brands',
        },
        {
          name: 'John Lewis for Business',
          url: '/business',
        },
      ],
    },
    {
      name: 'Help',
      menuLinks: [
        {
          name: 'Customer services',
          url: '/customer-services',
        },
        {
          name: 'Track your order',
          url: `${baseUrl || ''}/track-order`,
        },
        {
          name: 'Returns and refunds',
          url: '/customer-services/returns',
        },
        {
          name: 'Delivery and collection',
          url: '/customer-services/delivery-information',
        },
        {
          name: 'Product support',
          url: 'https://productsupport.johnlewis.com',
        },
        {
          name: 'Contact us',
          url: '/customer-services/contact-us',
        },
      ],
    },
    {
      name: 'My John Lewis',
      url: '/our-services/my-john-lewis',
    },
    {
      name: 'Our stores',
      url: '/our-shops',
      menuLinks: [],
    },
  ];

  return links;
};

export const getAccountLinks = (baseUrl?: string, myAccountUrl?: string) => [
  {
    name: 'My account',
    url: myAccountUrl || '/my-account',
  },
  {
    name: 'Online orders',
    url: `${baseUrl || ''}/orders`,
  },
  {
    name: 'My John Lewis rewards',
    url: `${baseUrl || ''}/rewards`,
  },
  {
    name: 'My reviews',
    url: `${baseUrl || ''}/my-reviews`,
  },
  {
    name: 'Wish list',
    url: `${baseUrl || ''}/wish-list`,
  },
  {
    name: 'Appointments',
    url: '/appointments/manage',
  },
  {
    name: 'Sign out',
    url: '/sign-out',
  },
];

export const FEEDBACK_LINK =
  'https://edigitalsurvey.com/survey/enter/s/ESV-136225211/data2/mobile/collection_url/';
